<header class="fixed">
  <div
    class="background"
    [ngStyle]="{ marginLeft: Margin }"
    [class.radius]="HasIndex"
  ></div>
  <div class="nav-entry">
    <a href="/#top"><img src="../../assets/icons/home.svg" /> Home</a>
  </div>
  <div class="nav-entry">
    <a href="/#angebot">Leistungen </a>
  </div>
  <div class="nav-entry">
    <a href="/#jobs">Jobs/Karriere</a>
  </div>
  <div class="nav-entry">
    <a href="/#standort">Kontakt</a>
  </div>
</header>
<!--<header class="hidden">
  <div class="background"></div>
  <div class="nav-entry">
    <a href="/#top"><img src="../../assets/icons/home.svg" /> Home</a>
  </div>
  <div class="nav-entry">
    <a href="/#angebot">Leistungen </a>
  </div>
  <div class="nav-entry">
    <a href="/#jobs">Jobs/Karriere</a>
  </div>
  <div class="nav-entry">
    <a href="/#standort">Kontakt</a>
  </div>
</header>-->
<header class="mobile grid">
  <div>
    <span><!--Elektrotechnik Leutgeb--></span>
    <div class="burger" [class.open]="open" (click)="open = !open">
      <div class="burger-bar-1"></div>
      <div class="burger-bar-2"></div>
      <div class="burger-bar-3"></div>
    </div>
  </div>
</header>
<!--<header class="mobile grid hidden">
  <div>
    Elektrotechnik Leutgeb
    <div class="burger" [class.open]="open" (click)="open = !open">
      <div class="burger-bar-1"></div>
      <div class="burger-bar-2"></div>
      <div class="burger-bar-3"></div>
    </div>
  </div>
</header>-->
<nav [class.open]="open" (click)="close()">
  <div class="nav-content">
    <div>
      <a href="/#top"> Home</a>
    </div>
    <div>
      <a href="/#angebot">Leistungen </a>
    </div>
    <div>
      <a href="/#jobs">Jobs/Karriere</a>
    </div>
    <div>
      <a href="/#standort">Kontakt</a>
    </div>
  </div>
</nav>
